import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-check"
}
const _hoisted_2 = ["checked", "disabled", "id", "title"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["checked", "disabled", "id", "title"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Found illegal mode ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")!
  const _component_FormGridMember = _resolveComponent("FormGridMember")!

  return (this.isFlexMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          checked: _ctx.modelValue,
          onChanged: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.changed && this.changed(...args))),
          disabled: _ctx.disabled,
          id: this.id != null ? this.id : _ctx.$id('checkBox'),
          title: this.title,
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changed && _ctx.changed(...args))),
          ref: "checkbox"
        }, null, 40, _hoisted_2),
        (this.label != null)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              class: "form-check-label",
              for: this.id != null ? this.id : _ctx.$id('checkBox')
            }, _toDisplayString(this.label), 9, _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    : (this.isFormGridMode)
      ? (_openBlock(), _createBlock(_component_FormGridMember, { key: 1 }, {
          control: _withCtx(({ id : id }) => [
            _createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              checked: _ctx.modelValue,
              onChanged: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (this.changed && this.changed(...args))),
              disabled: _ctx.disabled,
              id: id,
              title: this.title,
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changed && _ctx.changed(...args))),
              ref: "checkbox"
            }, null, 40, _hoisted_4)
          ]),
          labelSecond: _withCtx(({ controlId : controlId, class : clazz }) => [
            (this.label != null)
              ? (_openBlock(), _createBlock(_component_Label, {
                  key: 0,
                  class: _normalizeClass(`col-form-label text-md-start ${clazz}`),
                  for: controlId
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(this.label), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "for"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_5
        ], 64))
}